import React, { Component } from 'react';

import { ButtonDropdown, Col, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import notesIcon from '../../../../public/img/notes/notes_icon1.svg';
import ChapterCard from '../../../Components-2025/QuestionBank/ChapterCards';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import ComponentHeader from '../../../common/ComponentHeader';
import { nextAwareRoute, isNextPath } from '../../../common/cfa1NextRoutes';
import { openPDF } from '../../../common/function';
import { messages } from '../../../common/messages';
import { showInformation } from '../../../common/toast';
import ModalComponent from '../../Common/Modal';
import config from '../../config/AppRoutes';
import {
  chapterIdKey,
  chapterNameKay,
  readingIdKey,
  tableChapterKey,
  tableKey,
  totalNotesKey,
  totalReadingKey,
} from './ApiAttributesKays';
import apiServiceProvider from './ApiService';

/* eslint-disable*/

export class Notes extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      chapterId: '',
      questionId: '',
      isLoading: true,
      isLastReadNoteButtonDisable: false,
      isPdfDownloadDropdownOpen: false,
      isUserSubscribed: false,
      openPremiumPopup: false,
      chapterData: [],
      isAdditionalResourceSheetavailable: false
    };
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
  componentDidMount = async () => {
    const {
      location: { state },
    } = this.props;
    if (!(state && state.chapterData)) {
      this.getChapterWiseCount();
    } else {
      this.setState({ ...state, isLoading: false });
    }
  };
  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================

  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================

  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
  getChapterWiseCount = async () => {
    try {
      const { data, selectedExamSubscriptionDetails, success } = await apiServiceProvider['fetchChaptersWithPremiumAndFreeCount']();
      if (success && data && selectedExamSubscriptionDetails) {
        const { level1SubscriptionDetails } = selectedExamSubscriptionDetails
        this.setState({
          chapterData: data,
          isUserSubscribed: level1SubscriptionDetails && level1SubscriptionDetails.noteStatus,
          isAdditionalResourceSheetavailable: level1SubscriptionDetails && Object.keys(level1SubscriptionDetails).length // it makes Ratio and Formula sheet available for all levels of CFA Level I packages
        });
      }
    } catch (error) {
      console.error("getChapterWiseCount error", error)
    } finally {
      setTimeout(() => this.setState({ isLoading: false }), 500);
    }
  };

  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================

  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
  redirectToLastNoteRead = async () => {
    this.setState({ isLastReadNoteButtonDisable: true });
    const result = await apiServiceProvider['fetchLastNoteRead']();
    this.setState({ isLastReadNoteButtonDisable: false });

    //* FIRST OF ALL CHECK THE REDIRECTION
    if (result.success) {
      const { data } = result;
      const { router } = this.context;
      // The last-read note comes back under the per-year association alias
      // (cfa1_2025_note for 2025/2026, cfa1_2027_note for 2027). tableKey is hardcoded to
      // the 2025 alias, so for 2027 data[tableKey] was undefined and the redirect threw,
      // leaving the button stuck. Resolve the alias for the selected exam.
      const selectedExam = localStorage.getItem('selectedmenu');
      const noteAlias = selectedExam === 'cfa_2027' ? 'cfa1_2027_note' : tableKey;
      const lastNote = data && data[noteAlias];
      if (lastNote) {
        router.push({
          pathname: nextAwareRoute(config.CFA1_2025_NOTES_VIEW).replace(':readingId', lastNote[readingIdKey])
            .replace(':notesId', lastNote.id)
            .replace(':chapterId', lastNote[tableChapterKey]),
        });
      } else {
        showInformation(messages.NOTES_NOT_AVAILABLE);
      }
    } else {
      showInformation(messages.NOTES_NOT_AVAILABLE);
    }
  };
  //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };

  onPdfDownloadDropDownToggle = () => {
    this.setState({
      isPdfDownloadDropdownOpen: !this.state.isPdfDownloadDropdownOpen,
    });
  };

  onHandleDownloadSheet = async type => {
    // 2027 (/cfa1/2027/...) has its own Additional Resources set; every other CFA1 edition
    // shares 'cfa_1'. isNextPath() reads the URL, so the same reused component picks the right one.
    const exam = isNextPath() ? 'cfa_2027' : 'cfa_1';
    const result = await apiServiceProvider['fetchAdditionalResourcesPdf']({ exam, type });
    if (result.success) {
      openPDF(result);
    } else {
      showInformation(messages.SHEET_NOT_AVAILABLE.replace(':sheet', type));
    }
  };
  render() {
    const { state, context } = this;
    const {
      imageWidth,
      isLoading,
      openPremiumPopup,
      chapterData,
      isUserSubscribed,
      isLastReadNoteButtonDisable,
      isPdfDownloadDropdownOpen,
      isAdditionalResourceSheetavailable
    } = state;
    const { router } = context;

    return (
      <div className='animated fadeIn'>
        {/*//*================================================={{ CFA I 2025 NOTES START HERE }}================================================  */}

        <ComponentHeader title={messages.NOTES}>
          <div className='ml-auto'>
            <ButtonDropdown
              isOpen={isPdfDownloadDropdownOpen}
              toggle={() =>
                isAdditionalResourceSheetavailable ? this.onPdfDownloadDropDownToggle() : this.toggleAlert()
              }
            >
              <DropdownToggle
                className='btn btn-primary overflow-hidden pointer_class tooltip_wrap'
                caret
              >
                {!isAdditionalResourceSheetavailable && <div className='premium-download'>Premium</div>}
                {messages.ADDITIONAL_RESOURCES}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  value='public'
                  onClick={() => {
                    this.onHandleDownloadSheet('Ratio sheet');
                  }}
                >
                  <i className='fa fa-print color-black' aria-hidden='true' />
                  {messages.RATIO_SHEET}
                </DropdownItem>
                <DropdownItem
                  value='private'
                  onClick={() => {
                    this.onHandleDownloadSheet('Formula sheet');
                  }}
                >
                  <i className='fa fa-print color-black' aria-hidden='true' />
                  {messages.FORMULA_SHEET}
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
          </div>
          <button
            className='btn btn-primary pointer_class'
            onClick={() => this.redirectToLastNoteRead()}
            disabled={isLastReadNoteButtonDisable}
          >
            {isLastReadNoteButtonDisable && <i className='fa fa-spinner fa-spin mr-1' />}
            {messages.GO_TO_MY_LAST_READ_NOTE}
          </button>
        </ComponentHeader>
        <LoaderWrapper isLoading={isLoading}>
          <Row>
            <Col className='seperator-block-wrap'>
              <div className='card'>
                <div className='card-block'>
                  <Row>
                    {chapterData.length > 0 &&
                      chapterData.map((item, index) => {
                        return (
                          <ChapterCard
                            onClick={() =>
                              isUserSubscribed || index === 0
                                ? router.push({
                                    pathname: nextAwareRoute(config.CFA1_2025_NOTES_READING_LIST).replace(
                                      ':chapterId',
                                      item[chapterIdKey],
                                    ),
                                    state: { chapterData },
                                  })
                                : this.toggleAlert()
                            }
                            key={item[chapterIdKey]}
                            chapterOrder={index + 1}
                            headerImage={notesIcon}
                            headerImageWidth={imageWidth}
                            chapterNumber={item[chapterIdKey]}
                            chapterName={item[chapterNameKay]}
                            totalNotes={item[totalNotesKey]}
                            totalReadings={item[totalReadingKey]}
                            userSubscriptionDetails={isUserSubscribed}
                            callingComponent='notes'
                            free={index === 0}
                            {...this.props}
                          />
                        );
                      })}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </LoaderWrapper>

        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={messages.CFA1_PREMIUM_POPUP}
        />
        {/*//*================================================={{ CFA I 2025 NOTES ENDED HERE }}================================================  */}
      </div>
    );
  }
}

export default Notes;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/index.jsx